export default function (initialButtonType = null, defaultContext = {}, extraState = {}) {

    const HASH_MODAL = '#modal';

    return {
        openLoanOrder: false,
        buttonType: initialButtonType,
        defaultContext,
        leadContext: {},
        ...extraState,

        init() {
            this.setContext();

            if (window.location.hash === HASH_MODAL) {
                this.openLoanOrder = true;
                this.emitContext();
            }
            window.addEventListener('hashchange', () => {
                const shouldOpen = window.location.hash === HASH_MODAL;
                this.openLoanOrder = shouldOpen;

                if (shouldOpen) {
                    this.setContext();
                    this.emitContext();
                }
            });
        },

        setContext(context = {}) {
            const pageTitle = document.querySelector('h1')?.innerText?.trim() || null;

            const pageUrl = window.location.href;

            // @TODO Переделать, решение компромиссное
            //
            // ВАЖНО!!!: порядок spread операторов критичен для корректной работы
            // 1. Сначала defaultContext (базовые значения)
            // 2. Затем специфические поля с fallback логикой
            // 3. В конце context (может динамически перезаписать любые значения)
            this.leadContext = {
                ...this.defaultContext,
                entry_point: this.defaultContext.entry_point ?? this.buttonType ?? 'loan_modal',
                entry_button_type: this.buttonType ?? this.defaultContext.entry_button_type ?? 'loan_modal',
                entry_page_title: this.defaultContext.entry_page_title ?? pageTitle,
                entry_page_url: this.defaultContext.entry_page_url ?? pageUrl,
                ...context,
            };
        },

        emitContext() {
            if (window.Livewire && typeof window.Livewire.emit === 'function') {
                window.Livewire.emit('loan-order-context', this.leadContext);
            }
        },

        pushAnalytics() {
            const pageName = this.leadContext.entry_page_title
                ?? document.querySelector('h1')?.innerText
                ?? 'H1 не найден';

            if (window.GTM && typeof window.GTM.send === 'function') {
                window.GTM.send('broker_start', this.buttonType, pageName);
            }
        },

        handleClick(context = {}) {
            this.setContext(context);
            this.emitContext();
            this.openLoanOrder = true;
            this.pushAnalytics();
        },
    };
}
